
<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline"  label-width="100px" size="mini">
        <div class="formItemBox">
          <el-form-item label="年月:" class="">
            <el-date-picker
              style="width:150px"
              v-model="searchFrom.priceDate"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="选择年月">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="卸点:" class="">
            <el-input maxlength="" v-model.trim="searchFrom.destination" style="width:180px;"></el-input>
          </el-form-item>
          <!-- <el-form-item label="货物类型:" class="">
            <el-select v-model="searchFrom.productType" filterable placeholder="请选择" style="width:150px">
              <el-option label="全部" value="" ></el-option>
              <el-option v-for="item in HWlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
            </el-select>
          </el-form-item> -->
          <!-- <el-form-item label="价格区间:" class="">
            <el-input maxlength="11" v-model.trim="searchFrom.Price" v-number-input.float="2" style="width:100px;"></el-input>
            <span style="margin:0 5px;">-</span>
            <el-input maxlength="11" v-model.trim="searchFrom.PriceT" v-number-input.float="2"
            style="width:100px;"></el-input>
          </el-form-item> -->
        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" @click="THimportFn()">导入</el-button>
            <!-- <el-button type="primary" size="mini" @click="exportFn" :disabled="isDisable">导出</el-button> -->
            <!-- <el-button type="primary" size="mini" @click="editFN">修改</el-button>
            <el-button type="primary" size="mini">删除</el-button> -->
          </div>
        </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" @selection-change="selectGoods" @row-click="handleRowClick"
      class="tableComent" height="100%" style="width:100%" center border>
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" width="55" label="序号"></el-table-column>
        <el-table-column prop="priceDate" label="年月" width="120" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="destination" label="卸点" width="400" :formatter="formatterRowEmpty" show-overflow-tooltip></el-table-column>
        <el-table-column prop="kilometres" label="运距(公里)" width="" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="zhbPrice" label="中厚板价格(元)" width="" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="ljPrice" label="冷卷价格(元)" width="" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="rjPrice" label="热卷价格(元)" width="" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170" :formatter="dateTimeFormat"></el-table-column>
        <el-table-column prop="createUser" label="创建人" width=""></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 导入 -->
    <importC v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
  </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { getDictionaryDetailList, importShougangPrice, shougangList } from '@/api/newTMS'
import { formatterRowEmpty, dateTimeFormat, dateFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import importC from '@/views/newTMS/publicFiles/importTMS.vue'
export default {
  components: {
    importC
  },
  data () {
    return {
      exportMark: false,
      formatterRowEmpty: formatterRowEmpty,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      h: 500,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      total: 0,
      loading: false,
      rules: {
        subcontractType: [
          { required: true, message: '请选择转包类型', trigger: 'blur' }
        ]
      },
      btnFlg: [],
      btnIdArr: ['01N0010100', '01N0010200'],
      isDisable: false,
      importDialog: false,
      HWlist: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/shouGangPrice')
    this.getList(this.searchFrom)
    getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => { this.HWlist = res })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 166 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 修改
    editFN () {
    },
    exportList (val) {
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      form.header = val
      exportExcel(
        this.global.tmsPlus + '/order/exportOrderList',
        form,
        '订单列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 导出
    exportFn () {
      this.exportMark = true
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      var that = this
      selection.forEach((item) => {
        // that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      shougangList(searchFrom).then((res) => {
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    // 导入
    THimportFn () {
      console.log(this.searchFrom.priceDate, 'this.searchFrom.priceDate')
      if (!this.searchFrom.priceDate) {
        this.$alert('请选择年月', '系统提示')
      } else {
        this.importDialog = true
      }
    },
    destroy () {
      this.importDialog = false
    },
    DRsave (formData) {
      // formData.append('MultipartFile', 'excl')
      let form = {
        priceDate: this.searchFrom.priceDate
      }
      formData.append('params', JSON.stringify(form))
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      importShougangPrice(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        console.log(res, 'res')
        this.msg = this.$message({
          showClose: false,
          message: '导入成功',
          type: 'success',
          onClose () {}
        })
        this.getList(this.searchFrom)
      }).catch(error => {
        this.msg = this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width: 420px!important;
}
/deep/.el-form{
  width: 100%;
}
.box{
  width: 100%;
   display: grid;
   grid-template-columns: repeat(auto-fill, 270px);
   grid-auto-flow: row dense;
   /deep/.el-textarea__inner{
    width: 150px;
    height: 68px;
   }
   .item1{
      grid-row-start: span 2;
    }
   .item2{
      grid-column-start: span 2;
      //width: 540px;
   }
}
</style>
